import { Checkbox } from "@progress/kendo-react-inputs";

export const RevisionCountProperty = {
  propertyName: "RevisionCount",
  propertyDisplay: "Track Revisions",
  propertyType: "boolean",
  propertyCategory: "Data",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Checkbox
        name={this.propertyName}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        value={currentPropertyValues?.[this.propertyName] || false}
      />
    );
  },
};
